import { useEffect, useState } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import { PromptModal } from './PromptSelectorButton';

export const DrawerCollectionSkeleton = ({ visible }) => {
  const [shouldRender, setShouldRender] = useState(visible);

  useEffect(() => {
    if (visible) {
      setShouldRender(true);
    } else {
      const timeout = setTimeout(() => setShouldRender(false), 300);
      return () => clearTimeout(timeout);
    }
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      className={`
        w-[78%] mx-auto mt-1
        transition-opacity duration-300
        ${visible ? 'opacity-100' : 'opacity-0'}
      `}
    >
      <div className="rounded-xl bg-white p-6 border border-gray-200">
        <div className="flex items-center gap-3 mb-6">
          {/* 🔵 Bolinha azul pulsando e aumentando */}
          <div className="w-5 h-5 bg-blue-800 rounded-full animate-pulse-grow" />
          <Skeleton
            style={{ backgroundColor: '#d1d5db', opacity: 1 }}
            height={30}
            width="100%"
          />
        </div>

        <div className="space-y-2 mb-6">
          {[1, 2, 3].map((_, i) => (
            <Skeleton
              key={i}
              height={25}
              width="100%"
              // style={{ backgroundColor: '#d1d5db', opacity: 1 }}
            />
          ))}
        </div>

        <div className="flex gap-4">
          <Skeleton
            height={36}
            width={120}
            // style={{ backgroundColor: '#d1d5db', opacity: 1 }}
          />
          <Skeleton
            height={36}
            width={140}
            style={{ backgroundColor: '#d1d5db', opacity: 1 }}
          />
        </div>
      </div>
    </div>
  );
};

// import Skeleton from '@material-ui/lab/Skeleton';

// export const DrawerCollectionSkeleton = ({ visible }) => {
//   if (!visible) return null;

//   return (
//     <div style={{ marginBottom: '100px', width: '63%', margin: '0 auto' }}>
//       <div className="card-result">
//         <div className="content-card">
//           <div className="title-modal-search-result">
//             <Skeleton circle={true} height={20} width={20} />
//             <Skeleton height={20} width={100} style={{ marginLeft: '10px' }} />
//             <Skeleton height={20} width={40} style={{ marginLeft: '10px' }} />
//           </div>
//           <div className="data-search-results">
//             <Skeleton height={15} width={15} />
//             <Skeleton height={15} width={150} style={{ marginLeft: '10px' }} />
//           </div>
//         </div>

//         <div className="text-info">
//           <Skeleton height={20} width={200} />
//           <Skeleton count={5} />
//         </div>

//         <div className="buttons">
//           <div className="copy-reload-buttons">
//             <Skeleton height={40} width={80} />
//             <Skeleton height={40} width={40} style={{ marginLeft: '10px' }} />
//           </div>
//           <div className="copy-reload-buttons">
//             <Skeleton height={15} width={150} />
//             <Skeleton height={40} width={40} style={{ marginLeft: '10px' }} />
//             <Skeleton height={40} width={40} style={{ marginLeft: '10px' }} />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };
